import { Component, Input, OnInit } from '@angular/core';

import { IColunaStatus } from '../../interface/icm-status-generico';

@Component({
    selector: 'icm-coluna-status',
    templateUrl: './view/icm-coluna-status.component.html',
    styleUrls: ['./view/icm-coluna-status.component.scss'],
})
export class IcmColunaStatusComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaStatus;
    @Input() carregando: boolean;

    valor: number | string | Date;
    corTexto: string = '#000000de';
    corFundo: string = 'transparent';
    corDesabilitado: string = '#00000042';
    textoTooltip: string;

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.valor = this.coluna.valor(this.linha);
        if (this.coluna?.corTexto) this.corTexto = this.coluna.corTexto(this.linha);
        if (this.coluna?.corFundo) this.corFundo = this.coluna.corFundo(this.linha);
        if (this.coluna?.tooltip)
            this.textoTooltip = this.coluna.tooltip.valor(this.linha);
    }
}
